import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { evaluate } from "mathjs";
import { NumberFormatProps } from "./types";

export default function NumberFormat(props: NumberFormatProps): React.ReactElement {
  const { onChange, onBlur, value, decimalPlaces: _decimalPlaces, ...rest } = props;
  const regexCheckNumberOrOperator =
    /^((\d{1,})?(\.)?(\d{1,})?([-+*/])?(\d{1,})?(\.)?(\d{1,})?)+$/g;
  const regexCheckNumberOrCalculation =
    /(?:(?:^|[-+_*/])(?:\s*-?\d+(\.\d+)?(?:[eE][+-]?\d+)?\s*))+$/;
  const [displayValue, setDisplayValue] = useState<string>();

  useEffect(() => {
    if (!isNaN(Number(value)) && value !== displayValue) {
      setDisplayValue(Number(value).toFixed(2));
    }
  }, [value]);

  const isNumber = !isNaN(Number(value)) && Number(value) !== Infinity;
  const newValue = isNumber ? Number(value).toFixed(2) : "0.00";

  return (
    <Input
      data-hj-allow
      className="text-align-right"
      maxLength={15}
      onFocus={e => {
        e.target.select();
      }}
      onChange={e => {
        const value = e.target.value;
        if (value.match(regexCheckNumberOrOperator)) {
          onChange?.(value);
          setDisplayValue(value);
        }
      }}
      onBlur={e => {
        onBlur?.(e);
        let value = e.target.value;

        if (regexCheckNumberOrCalculation.test(value)) {
          value = evaluate(value);
        } else {
          value = "";
        }
        const isNumber = value !== "" && !isNaN(Number(value)) && Number(value) !== Infinity;

        const rawVal = isNumber ? parseFloat(Number(value).toFixed(9)) : 0;
        const positiveOrNegative = isNumber
          ? Number(value) > 0
            ? Math.abs(Number(value)).toFixed(2)
            : -Math.abs(Number(value)).toFixed(2)
          : "";

        onChange?.(rawVal);
        setDisplayValue(value && isNumber ? String(positiveOrNegative) : "");
      }}
      value={displayValue || newValue}
      {...rest}
    />
  );
}
